import { RtkEmptySplitApi } from "../../types";
import { IntegrationsApiTag } from "../integrations/tags";
import { SubscriptionTags } from "../subscription/tags";
import {
  ShopifyLookupParams,
  ShopifyLookupResponse,
  ShopifyOAuthCreateRequest,
  ShopifyOAuthCreateResponse,
} from "./types";

export const addShopifyApi = (emptySplitApi: RtkEmptySplitApi) => {
  const apiWithTags = emptySplitApi.enhanceEndpoints({
    addTagTypes: [
      IntegrationsApiTag.shopifyAccount,
      SubscriptionTags.subscriptionDetails,
    ],
  });
  const shopifyApi = apiWithTags.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      // Common for internal and external flows. Not entity-scoped;
      // the Bearer token is attached by the axios request interceptor
      createShopifyOAuth: build.mutation<
        ShopifyOAuthCreateResponse,
        { data: ShopifyOAuthCreateRequest }
      >({
        query: ({ data }) => ({
          url: `/api/shopify/oauth/create`,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data,
          silentError: true,
        }),
        invalidatesTags: [
          IntegrationsApiTag.shopifyAccount,
          SubscriptionTags.subscriptionDetails,
        ],
      }),

      /**
       * Resolve the Jugl workspace linked to a Shopify store.
       * Used on app launch (`session` present) so we can switch the user
       * into the already-connected entity.
       */
      lookupShopifyConnection: build.query<
        ShopifyLookupResponse,
        ShopifyLookupParams
      >({
        query: ({ key, value }) => ({
          url: `/api/connections/shopify/lookup`,
          method: "GET",
          params: { key, value },
        }),
        providesTags: [IntegrationsApiTag.shopifyAccount],
      }),
    }),
  });

  return shopifyApi;
};

export type ShopifyApi = ReturnType<typeof addShopifyApi>;
